import React, { useEffect, useRef, useState } from 'react';
import BarcodeCamera from './BarcodeCamera';
import '../styles/produccion.css';

// One field for the gun, the keyboard and the camera. It keeps the focus so
// the next scan lands in it without a tap. With several on a page, only the
// one with `autoFocus` takes the focus (on mount, when `autoFocus` turns on and
// on each `focusKey` change); the others get it back only after their own scans.
// `onType` hears every change and `onArrow` the ↑/↓ keys, for a list of matches;
// with a list, an empty Enter reaches `onScan('')` (it picks the highlighted row)
// and camera reads come as `onScan(code, { camera: true })`.
function ProduccionScanInput({
  placeholder, onScan, disabled = false, focusKey, autoFocus = true, onType, onArrow,
}) {
  const input = useRef(null);
  const wasDisabled = useRef(disabled);
  const [value, setValue] = useState('');
  const [cameraOpen, setCameraOpen] = useState(false);
  const [cameraError, setCameraError] = useState('');

  const focus = () => {
    if (input.current) input.current.focus();
  };

  useEffect(() => {
    if (autoFocus) focus();
  }, [focusKey, autoFocus]);
  useEffect(() => {
    if (wasDisabled.current && !disabled) focus();
    wasDisabled.current = disabled;
  }, [disabled]);

  // The gun types the code and sends Enter.
  const handleKeyDown = (event) => {
    if (onArrow && (event.key === 'ArrowDown' || event.key === 'ArrowUp')) {
      event.preventDefault();
      onArrow(event.key === 'ArrowDown' ? 1 : -1);
      return;
    }
    if (event.key !== 'Enter') return;
    event.preventDefault();
    const code = value.trim();
    setValue('');
    if (!code && !onArrow) return;
    onScan(code);
    focus();
  };

  const handleCameraScan = (text) => {
    const code = String(text || '').trim();
    if (!code) return;
    setCameraOpen(false);
    onScan(code, { camera: true });
    focus();
  };

  const toggleCamera = () => {
    setCameraError('');
    setCameraOpen((open) => !open);
  };

  return (
    <div className="prod-scan prod-noprint">
      <div className="prod-field">
        <input
          ref={input}
          type="text"
          className="prod-scan-input"
          placeholder={placeholder}
          aria-label={placeholder}
          value={value}
          disabled={disabled}
          autoFocus={autoFocus}
          autoComplete="off"
          onChange={(event) => {
            setValue(event.target.value);
            if (onType) onType(event.target.value);
          }}
          onKeyDown={handleKeyDown}
        />
        <button
          type="button"
          className="prod-scan-btn"
          aria-label="Usar la cámara"
          disabled={disabled}
          onClick={toggleCamera}
        >
          📷
        </button>
      </div>
      {cameraOpen && (
        <div className="prod-camera">
          <BarcodeCamera
            onScan={handleCameraScan}
            onError={() => {
              setCameraOpen(false);
              setCameraError('No se pudo abrir la cámara. Usa la pistola o escribe el código.');
            }}
          />
        </div>
      )}
      {cameraError && <div className="prod-bad">{cameraError}</div>}
    </div>
  );
}

export default ProduccionScanInput;
